{
  "title": "Создайте первую учётную запись",
  "lead": "Вы станете владельцем этой установки CloudServer.",
  "code": "Код установки",
  "codeHint": "Его выдаёт тот, кто установил CloudServer (BOOTSTRAP_CODE).",
  "organization": "Название организации",
  "name": "Ваше имя",
  "email": "E-mail",
  "password": "Пароль (необязательно)",
  "passwordHint": "Не меньше 12 символов. Можно входить только по passkey и оставить поле пустым.",
  "submit": "Создать учётную запись"
}
